import styled from 'styled-components';

import { SpaceBetweenBlock, VerticalCenterBlock } from '../../../styled';

export const SelectorsWrapper = styled(SpaceBetweenBlock)`
  max-width: 538px;
  height: 100%;
  color: ${(p) => p.theme.colors.muted};
`;

export const FieldGroupWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
  margin-right: 16px;
  min-width: 261px;

  :last-child {
    margin-right: 0;
  }
`;

export const LabelWrapper = styled(VerticalCenterBlock)`
  ${(p) => p.theme.typography.descriptionCompact};
  min-height: 24px;
  margin-bottom: 4px;
`;
